import z from "zod";

export const UnlockOverlayEventName = z.literal("UnlockOverlay");
export type UnlockOverlayEventName = z.infer<typeof UnlockOverlayEventName>;

export const UnlockOverlayEventDetail = z.object({
  show: z.boolean(),
  animated: z.boolean(),
});
export type UnlockOverlayEventDetail = z.infer<typeof UnlockOverlayEventDetail>;

export const UnlockOverlayEventData = z.object({
  name: UnlockOverlayEventName,
  detail: UnlockOverlayEventDetail,
});
export type UnlockOverlayEventData = z.infer<typeof UnlockOverlayEventData>;

export const UnlockOverlayEvent = (show: boolean, animated = false): UnlockOverlayEventData => ({
  name: UnlockOverlayEventName.value,
  detail: { show, animated },
});
